import React, { useEffect, useState } from "react";
import Card from "./components/card/Card";
import "./home.scss";
import FormTitle from "./components/formTitle/FormTitle";
import ModalDialog from "./components/modal/ModalDialog";
import apiClient from "./common/apiClient";
import { ClipLoader } from "react-spinners";
import { GetAccountPermission } from "../src/common/common";

let formName = [
  {
    name: "TT Check Socket",
    to: "ttchecksocket",
    isBilateral: true,
  },
  {
    name: "TF Check Socket",
    to: "tfchecksocket",
    isBilateral: true,
  },
  /*{ //Temporarily hidden
    name: "WillowWood Core™ TT with RevoFit",
    to: "ttstandardrevo",
  },
  {
    name: "WillowWood Core™ TF with RevoFit",
    to: "tfstandardrevo",
  },*/
  {
    name: "TT Definitive Socket",
    to: "ttdefinitive",
    isBilateral: true,
  },
  {
    name: "TF Definitive Socket",
    to: "tfdefinitive",
    isBilateral: true,
  },
  /*{ //Temporarily hidden
    name: "TT One® Socket",
    to: "ttonesocket",
  },
  {
    name: "TF One® Socket",
    to: "tfonesocket",
  },
  {
    name: "Xtremity TT Socket",
    to: "ttxtremity",
    isBilateral: false,
  },
  {
    name: "Knee Bundle",
    to: "kneebundle",
    isBilateral: false,
  },*/
  {
    name: "Liners",
    to: "liners",
    isBilateral: false,
  },
  {
    name: "Feet",
    to: "feet",
    isBilateral: false,
  },
];

const Home = () => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("TT check socket");
  const [to, setTo] = useState("");

  const [value, setValue] = useState("2");
  const [isBilateral, setIsBilateral] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isMulti, setIsMulti] = useState(false);
  
  let accountNumber = localStorage.getItem("accountNumber");

  useEffect(async () => {
    let parentAccountNumber = localStorage.getItem("parentAccount");
    if (parentAccountNumber) {
      accountNumber = parentAccountNumber;
    }

    const hasMultiProductPermission = await GetAccountPermission(accountNumber, "MULTI_PRODUCT_LINERS")
    setIsMulti(hasMultiProductPermission);

    await GetAccountPermission(accountNumber, "DESIGN").then((hasDesignLinerPermission) => {
      let doesDesignLinerExist = formName.some(fn => fn.name === "Design Liners");
      if (hasDesignLinerPermission) {
        if (!doesDesignLinerExist) {
          formName.push({
            name: "Design Liners",
            to: "designliners",
            isBilateral: true,
          })
        }
        localStorage.setItem("parentAccount", accountNumber);
      } else {
        formName = formName.filter(fn => fn.name !== "Design Liners");
      }

      const parentAccountFromLS = localStorage.getItem("parentAccount");
      if (parentAccountFromLS) {
        localStorage.setItem("accountNumber", parentAccountFromLS);
      }
    }).catch((error) => {
      console.log(error)
    }).finally(() => {
      setIsLoading(false)
    })
  }, [])

  const handleChange = (event, selected) => {
    setValue(event.target.value);
    if (to.includes("-")) {
      const parts = to.split("-");
      const updatedString = parts[0] + "-" + event.target.value;
      setTo(updatedString);
    } else {
      setTo(to + "-" + event.target.value);
    }
  };

  const handleChangeOff = (value) => {
    setTo(value);
  };

  const handleClickOpen = (name, to,isBilateral) => {
    setTitle(name);
    setOpen(true);
    setTo(to);
    setIsBilateral(isBilateral)
  };
  const handleClose = () => {
    setOpen(false);
  };

  const makeLoadingText = () => {
    return (
      <div className="loader">
        <ClipLoader color="#000000" size={40} />
      </div>
    );
  }

  return (
    isLoading ? makeLoadingText() :
    <>
      <div className="">
        <div className="formCardWrapper">
          <FormTitle
            title="Order Forms for Custom Products"
            description="For your convenience, all WillowWood custom product order forms are listed below. "
          />
          <div className="formSelectCard">
            {formName.map((name) => (
              <Card
                key={name.name}
                formTitle={name.name}
                handleClickOpen={() => handleClickOpen(name.name, name.to, name.isBilateral)}
              />
            ))}
          </div>

          <div className="cardModal">
            <ModalDialog
              open={open}
              formTitle={title}
              handleClose={handleClose}
              to={to}
              value={value}
              handleChange={handleChange}
              isBilateral={isBilateral}
              handleChangeOff={handleChangeOff}
              isMulti={isMulti}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
